// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/DashboardFilterBar.js
//
// Purpose:
// Service CRM Dashboard Filters
//
// Approved Filters:
// - Date Range
// - Engineer
// - Status
// - Priority
// - Customer
//
// No Tenant Filter
// No Location Filter
//
// Multi-Tenant Scope handled by middleware.
// ======================================================================

import React from "react";

export default function DashboardFilterBar({

  filters,
  setFilters,

  onApply,
  onReset,
  onRefresh,

  engineers = [],
  customers = [],

}) {

  // ==========================================================
  // CHANGE
  // ==========================================================
  function handleChange(e) {

    const {
      name,
      value,
    } = e.target;

    setFilters((prev) => ({

      ...prev,

      [name]: value,

    }));
  }

  // ==========================================================
  // RENDER
  // ==========================================================
  return (

    <div
      style={{
        background: "#fff",

        borderRadius: 14,

        padding: 18,

        marginBottom: 20,

        boxShadow:
          "0 2px 8px rgba(0,0,0,0.06)",
      }}
    >

      {/* ==================================================== */}
      {/* TITLE */}
      {/* ==================================================== */}

      <div
        style={{
          fontSize: 16,

          fontWeight: 700,

          marginBottom: 16,

          color: "#212529",
        }}
      >
        Dashboard Filters
      </div>

      {/* ==================================================== */}
      {/* FILTERS */}
      {/* ==================================================== */}

      <div
        style={{

          display: "grid",

          gridTemplateColumns:
            "repeat(auto-fit, minmax(220px, 1fr))",

          gap: 14,
        }}
      >

        {/* DATE FROM */}

        <div>

          <label
            className="form-label"
          >
            Date From
          </label>

          <input
            type="date"

            className="form-control"

            name="from_date"

            value={
              filters?.from_date || ""
            }

            onChange={handleChange}
          />

        </div>

        {/* DATE TO */}

        <div>

          <label
            className="form-label"
          >
            Date To
          </label>

          <input
            type="date"

            className="form-control"

            name="to_date"

            value={
              filters?.to_date || ""
            }

            onChange={handleChange}
          />

        </div>

        {/* ENGINEER */}

        <div>

          <label
            className="form-label"
          >
            Engineer
          </label>

          <select
            className="form-select"

            name="engineer"

            value={
              filters?.engineer || ""
            }

            onChange={handleChange}
          >

            <option value="">
              All Engineers
            </option>

            {engineers.map(
              (engineer) => (

              <option
                key={engineer}

                value={engineer}
              >
                {engineer}
              </option>

            ))}

          </select>

        </div>

        {/* STATUS */}

        <div>

          <label
            className="form-label"
          >
            Status
          </label>

          <select
            className="form-select"

            name="status"

            value={
              filters?.status || ""
            }

            onChange={handleChange}
          >

            <option value="">
              All Status
            </option>

            <option value="OPEN">
              OPEN
            </option>

            <option value="ASSIGNED">
              ASSIGNED
            </option>

            <option value="IN_PROGRESS">
              IN PROGRESS
            </option>

            <option value="RESOLVED">
              RESOLVED
            </option>

            <option value="CLOSED">
              CLOSED
            </option>

          </select>

        </div>

        {/* PRIORITY */}

        <div>

          <label
            className="form-label"
          >
            Priority
          </label>

          <select
            className="form-select"

            name="priority"

            value={
              filters?.priority || ""
            }

            onChange={handleChange}
          >

            <option value="">
              All Priority
            </option>

            <option value="LOW">
              LOW
            </option>

            <option value="MEDIUM">
              MEDIUM
            </option>

            <option value="HIGH">
              HIGH
            </option>

            <option value="CRITICAL">
              CRITICAL
            </option>

          </select>

        </div>

        {/* CUSTOMER */}

        <div>

          <label
            className="form-label"
          >
            Customer
          </label>

          <select
            className="form-select"

            name="customer"

            value={
              filters?.customer || ""
            }

            onChange={handleChange}
          >

            <option value="">
              All Customers
            </option>

            {customers.map(
              (customer) => (

              <option
                key={customer}

                value={customer}
              >
                {customer}
              </option>

            ))}

          </select>

        </div>

      </div>

      {/* ==================================================== */}
      {/* ACTIONS */}
      {/* ==================================================== */}

      <div
        style={{

          display: "flex",

          justifyContent: "flex-end",

          gap: 10,

          marginTop: 20,

          flexWrap: "wrap",
        }}
      >

        <button
          type="button"

          className="btn btn-primary"

          onClick={onApply}
        >
          Apply
        </button>

        <button
          type="button"

          className="btn btn-outline-secondary"

          onClick={onReset}
        >
          Reset
        </button>

        <button
          type="button"

          className="btn btn-outline-success"

          onClick={onRefresh}
        >
          Refresh
        </button>

      </div>

    </div>
  );
}